import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import makeStyles from '@mui/styles/makeStyles';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import Link from '@mui/material/Link';
import Paper from '@mui/material/Paper';

import { DialogTitleWithClose } from 'ui';

const useStyles = makeStyles(theme => ({
  papers: {
    display: 'flex',
  },
  paper: {
    minWidth: '400px',
    padding: theme.spacing(2),

    '&:not(:last-child)': {
      marginRight: theme.spacing(2),
    },
  },
}));

const ContactUsModal = ({ open, onClose }) => {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <Dialog open={open} onClose={onClose} maxWidth={false}>
      <DialogTitleWithClose onClose={onClose}>{t('Contact us')}</DialogTitleWithClose>
      <DialogContent>
        <div className={classes.papers}>
          <Paper className={classes.paper}>
            <DialogContentText variant="h6">{t('Headquarters')}</DialogContentText>
            <DialogContentText>
              Scope SE & Co. KGaA
              <br />
              Lennéstraße 5<br />
              D-10785 Berlin
            </DialogContentText>
            <DialogContentText>
              {t('Phone')} +49 30 27891-0
              <br />
              {t('Fax')} +49 30 27891-100
              <br />
              {t('Service')} +49 30 27891-300
            </DialogContentText>
            <DialogContentText component="div">
              <Link href="emailto:servicecentre@scopegroup.com">servicecentre@scopegroup.com</Link>
              <br />
              <Link href="www.scopegroup.com" target="_blank">
                www.scopegroup.com
              </Link>
            </DialogContentText>
          </Paper>
          <Paper className={classes.paper}>
            <DialogContentText variant="h6">{t('Press')}</DialogContentText>
            <DialogContentText>
              Scope SE & Co. KGaA
              <br />
              Lennéstraße 5<br />
              D-10785 Berlin
            </DialogContentText>
            <DialogContentText>
              {t('Phone')} +49 30 27891-0
              <br />
              {t('Fax')} +49 30 27891-100
            </DialogContentText>
            <DialogContentText component="div">
              <Link href="emailto:press@scopegroup.com">press@scopegroup.com</Link>
            </DialogContentText>
          </Paper>
        </div>
      </DialogContent>
    </Dialog>
  );
};

ContactUsModal.defaultProps = {
  open: false,
  onClose: () => null,
};

ContactUsModal.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
};

export default ContactUsModal;
